import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ModalDirective} from "ngx-bootstrap";
import {ApolloQueryObservable} from "apollo-angular";
import {SearchInputComponent} from "../../ui/navigation/search-input/search-input.component";
import {KeyboardOptions} from "virtual-keyboard";
import {GERMAN_LAYOUT} from "../../ui/directives/on-screen-keyboard.directive";

@Component({
  selector: 'vb-search-result-modal',
  templateUrl: './search-result-modal.component.html',
  styleUrls: ['./search-result-modal.component.css']
})
export class SearchResultModalComponent implements OnInit, OnDestroy {

  kbOptions: KeyboardOptions = {
    type: 'input',
    layout: 'custom',
    customLayout: GERMAN_LAYOUT
  };

  @Input()
  touchMode: boolean = false;

  @ViewChild('searchResultsModal')
  modal: ModalDirective;

  @ViewChild('searchInput')
  searchInput: SearchInputComponent;

  @Input()
  modalTitle: string = "Suche";

  @Input()
  actionButtonTitle = "";

  @Input()
  searchQuery$: ApolloQueryObservable<any>;

  selectedItem = [];

  rows;
  isLoading: boolean;

  @Input()
  columns = [
    {
      name: 'Bezeichner',
      prop: 'label',
    }
  ];

  @Input()
  messages = {
    emptyMessage: 'Keine Suchergebnisse gefunden',
    totalMessage: 'insgesamt',
    selectedMessage: 'ausgewählt'
  };

  @Output()
  itemSelected: EventEmitter<any> = new EventEmitter();

  public isModalShown: boolean = false;

  constructor() {
  }

  ngOnInit() {
    this.selectedItem = [];
  }

  ngOnDestroy(): void {

  }

  public showModal(): void {
    this.isModalShown = true;
  }

  public hideModal(): void {
    this.selectedItem = [];
    this.searchInput.onClearClicked();
    this.modal.hide();
  }

  public onHidden(): void {
    this.isModalShown = false;
  }

  dataFound(result: any[]) {
    this.rows = result;
  }

  searchCleared() {
    this.rows = null;
  }

  onSelectedItemAction() {
    this.itemSelected.emit(this.selectedItem[0]);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/components/search-result-modal/search-result-modal.component.ts